import type {
  CheckinStatus,
  CheckoutStatus,
  Reservation,
  ReservationCustomQuestionAnswer,
} from "@/types/reservation";
import type { ReservationUpdateFormData } from "../guests/utils/reservationSchema";
import type { Request } from "@/types/request";
import { PreCheckStatus } from "@/components/pages/settlement/types/settlementBooking";

export type ReservationDetailsFormData = ReservationUpdateFormData &
  Pick<Reservation, "id" | "guest" | "room" | "reservationNumber"> & {
    serviceRequests: Request[];
    checkinStatus: CheckinStatus;
    checkoutStatus: CheckoutStatus;
    preCheckoutStatus: PreCheckStatus;
    pmsType: string | null;
    preferredLanguage: string;
    preCheckinReadAt: string | null;
    preCheckinCompletedAt: string | null;
    dateOfBirth: string | null;
    customQuestionAnswers: ReservationCustomQuestionAnswer[];
  };

export const mapReservationToUpdateFormData = (
  reservation: Reservation,
): ReservationDetailsFormData => ({
  id: reservation.id,
  guest: reservation.guest,
  room: reservation.room,
  reservationNumber: reservation.reservationNumber,
  guestId: reservation.guest.id,
  firstName: reservation.guest.profile.firstName || "",
  lastName: reservation.guest.profile.lastName || "",
  documents: reservation.guest.documents,
  email: reservation.guest.profile.email || "",
  phone: reservation.guest.profile.phone || "",
  language: reservation.guest.profile.language || "",
  roomId: reservation.room?.id || "",
  departureDate: reservation.departureDate || "",
  arrivalDate: reservation.arrivalDate || "",
  comments: reservation.checkinComments || "",
  photoId: reservation.guest.profile.photoId || null,
  bookingNumber: reservation.bookingNumber,
  bookingSource: reservation.bookingSource,
  status: reservation.status,
  roomType: reservation.room?.category?.name,
  pmsType: reservation.room?.category?.pmsType || null,
  preCheckinStatus: reservation.preCheckinStatus,
  preCheckoutStatus: reservation.preCheckoutStatus,
  preCheckinEnteredGuests:
    reservation.preCheckinStatus === PreCheckStatus.DONE ? 1 : 0,
  estimatedTimeOfArrival:
    reservation.estimatedTimeOfArrival || reservation.arrivalDate,
  preCheckinReadAt: reservation.preCheckinReadAt,
  preCheckinCompletedAt: reservation.preCheckinCompletedAt,
  customQuestionAnswers: reservation.customQuestionAnswers ?? [],
  checkinMethod: reservation.checkinMethod,
  serviceRequests: reservation.serviceRequests,
  additionalGuests:
    reservation.additionalGuests?.map((bg) => ({
      firstName: bg.guest.profile.firstName ?? "",
      lastName: bg.guest.profile.lastName ?? "",
      email: bg.guest.profile.email ?? "",
      phone: bg.guest.profile.phone ?? "",
      language: bg.guest.profile.language ?? "",
      dateOfBirth: bg.guest.profile.dateOfBirth ?? "",
      guestType: bg.guest.guestType,
    })) || [],
  checkinStatus: reservation.checkinStatus,
  checkoutStatus: reservation.checkoutStatus as CheckoutStatus,
  preferredLanguage: reservation.guest.profile.preferredLanguage,
  dateOfBirth: reservation.guest.profile.dateOfBirth || "",
  notes: reservation.notes ?? [],
});
